// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

const waitForAudioLoad = (audio: HTMLAudioElement): Promise<void> => {
  return new Promise((resolve) => {
    audio.onloadedmetadata = () => {
      resolve();
    };
  });
};

export const loadSoundEffectAudio = async (
  soundEffect: string,
  existingAudioElement?: HTMLMediaElement
): Promise<HTMLMediaElement> => {
  let audio;
  if (existingAudioElement) {
    audio = existingAudioElement;
    audio.src = `/audios/${soundEffect}.mp3`;
  } else {
    audio = new Audio(`/audios/${soundEffect}.mp3`);
  }
  await waitForAudioLoad(audio);
  return audio;
};

export const createBeepAudioTrackToSend = async (audio: HTMLMediaElement): Promise<MediaStream> => {
  const context = new AudioContext();
  const dest = context.createMediaStreamDestination();
  const source = context.createMediaElementSource(audio);
  source.connect(dest);
  const { stream } = dest;
  return stream;
};
